import { useState, useEffect } from 'react'
import Modal from '../Modal/Modal'
import TabsModal from '../TabsModal/TabsModal'
import ClientDetailsModal from '../ClientDetailsModal/ClientDetailsModal'
import BotManager from '../BotManager/BotManager'
import ResourcesManager from '../ResourcesManager/ResourcesManager'
import AdminStatsDashboard from '../AdminStatsDashboard/AdminStatsDashboard'
import GMManager from '../GMManager/GMManager'
import AnnouncementsManager from '../AnnouncementsManager/AnnouncementsManager'
import API from '../../services/apiService'
import { 
  Skeleton, 
  ClientsListSkeleton
} from '../Skeleton/Skeleton'
import './AdminPanel.css'

// Tab icons - Enhanced with gradients and shadows
const TabIcons = {
  clients: (
    <svg viewBox="0 0 24 24" width="18" height="18" className="tab-icon">
      <defs>
        <linearGradient id="clientGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#a5b4fc" />
          <stop offset="100%" stopColor="#6366f1" />
        </linearGradient>
        <filter id="tabShadow" x="-50%" y="-50%" width="200%" height="200%">
          <feDropShadow dx="0" dy="1" stdDeviation="1.5" floodOpacity="0.3"/>
        </filter>
      </defs>
      <circle cx="12" cy="7" r="4" fill="url(#clientGrad)" filter="url(#tabShadow)"/>
      <path d="M5 21c0-4 3-7 7-7s7 3 7 7" fill="url(#clientGrad)" filter="url(#tabShadow)"/>
    </svg>
  ),
  server: (
    <svg viewBox="0 0 24 24" width="18" height="18" className="tab-icon">
      <defs>
        <linearGradient id="serverGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#86efac" />
          <stop offset="100%" stopColor="#22c55e" />
        </linearGradient>
        <filter id="serverShadow">
          <feDropShadow dx="0" dy="1" stdDeviation="1.5" floodOpacity="0.3"/>
        </filter>
      </defs>
      <rect x="2" y="3" width="20" height="6" rx="1.5" fill="url(#serverGrad)" stroke="#15803d" strokeWidth="0.8" filter="url(#serverShadow)"/>
      <rect x="2" y="11" width="20" height="6" rx="1.5" fill="url(#serverGrad)" stroke="#15803d" strokeWidth="0.8" filter="url(#serverShadow)"/>
      <circle cx="6" cy="6" r="1.2" fill="#dcfce7" stroke="#15803d" strokeWidth="0.5"/>
      <circle cx="9" cy="6" r="1.2" fill="#dcfce7" stroke="#15803d" strokeWidth="0.5"/>
      <circle cx="6" cy="14" r="1.2" fill="#dcfce7" stroke="#15803d" strokeWidth="0.5"/>
      <circle cx="9" cy="14" r="1.2" fill="#dcfce7" stroke="#15803d" strokeWidth="0.5"/>
      <rect x="16" y="4" width="4" height="1.5" rx="0.3" fill="#15803d" opacity="0.6"/>
      <rect x="16" y="7" width="2" height="1" rx="0.3" fill="#15803d" opacity="0.6"/>
      <rect x="16" y="12" width="4" height="1.5" rx="0.3" fill="#15803d" opacity="0.6"/>
      <rect x="16" y="15" width="2" height="1" rx="0.3" fill="#15803d" opacity="0.6"/>
    </svg>
  ),
  stats: (
    <svg viewBox="0 0 24 24" width="18" height="18" className="tab-icon">
      <defs>
        <linearGradient id="statsGrad" x1="0%" y1="100%" x2="0%" y2="0%">
          <stop offset="0%" stopColor="#c084fc" />
          <stop offset="100%" stopColor="#9333ea" />
        </linearGradient>
        <filter id="statsShadow">
          <feDropShadow dx="0" dy="1" stdDeviation="1.5" floodOpacity="0.3"/>
        </filter>
      </defs>
      <path d="M3 13h4v8H3v-8z" fill="url(#statsGrad)" stroke="#6b21a8" strokeWidth="0.8" rx="0.5" filter="url(#statsShadow)"/>
      <path d="M10 5h4v16h-4V5z" fill="url(#statsGrad)" stroke="#6b21a8" strokeWidth="0.8" rx="0.5" filter="url(#statsShadow)"/>
      <path d="M17 9h4v12h-4V9z" fill="url(#statsGrad)" stroke="#6b21a8" strokeWidth="0.8" rx="0.5" filter="url(#statsShadow)"/>
    </svg>
  ),
  bot: (
    <svg viewBox="0 0 24 24" width="18" height="18" className="tab-icon">
      <defs>
        <linearGradient id="botTabGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#fef3c7" />
          <stop offset="50%" stopColor="#fbbf24" />
          <stop offset="100%" stopColor="#d97706" />
        </linearGradient>
        <filter id="botTabShadow">
          <feDropShadow dx="0" dy="1" stdDeviation="1.5" floodOpacity="0.3"/>
        </filter>
      </defs>
      <rect x="4" y="8" width="16" height="12" rx="3" fill="url(#botTabGrad)" stroke="#92400e" strokeWidth="0.8" filter="url(#botTabShadow)"/>
      <circle cx="9" cy="14" r="2" fill="#451a03"/>
      <circle cx="15" cy="14" r="2" fill="#451a03"/>
      <rect x="10" y="3" width="4" height="5" rx="2" fill="url(#botTabGrad)" stroke="#92400e" strokeWidth="0.6"/>
      <circle cx="12" cy="4" r="1.5" fill="#fbbf24"/>
    </svg>
  ),
  resources: (
    <svg viewBox="0 0 24 24" width="18" height="18" className="tab-icon">
      <defs>
        <linearGradient id="resourcesTabGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#fcd34d" />
          <stop offset="50%" stopColor="#f59e0b" />
          <stop offset="100%" stopColor="#d97706" />
        </linearGradient>
        <filter id="resourcesTabShadow">
          <feDropShadow dx="0" dy="1" stdDeviation="1.5" floodOpacity="0.3"/>
        </filter>
      </defs>
      <rect x="4" y="2" width="16" height="20" rx="2" fill="url(#resourcesTabGrad)" stroke="#92400e" strokeWidth="0.8" filter="url(#resourcesTabShadow)"/>
      <rect x="7" y="6" width="10" height="2" rx="0.5" fill="#78350f" opacity="0.6"/>
      <rect x="7" y="10" width="7" height="1.5" rx="0.3" fill="#78350f" opacity="0.4"/>
      <rect x="7" y="13" width="8" height="1.5" rx="0.3" fill="#78350f" opacity="0.4"/>
      <rect x="7" y="16" width="6" height="1.5" rx="0.3" fill="#78350f" opacity="0.4"/>
    </svg>
  ),
  gms: (
    <svg viewBox="0 0 24 24" width="18" height="18" className="tab-icon">
      <defs>
        <linearGradient id="gmsTabGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#fca5a5" />
          <stop offset="50%" stopColor="#ef4444" />
          <stop offset="100%" stopColor="#dc2626" />
        </linearGradient>
        <linearGradient id="gmsCrownGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#fcd34d" />
          <stop offset="100%" stopColor="#d97706" />
        </linearGradient>
        <filter id="gmsTabShadow">
          <feDropShadow dx="0" dy="1" stdDeviation="1.5" floodOpacity="0.3"/>
        </filter>
      </defs>
      <circle cx="12" cy="7" r="4" fill="url(#gmsTabGrad)" stroke="#991b1b" strokeWidth="0.8" filter="url(#gmsTabShadow)"/>
      <circle cx="12" cy="7" r="2" fill="#fecaca" opacity="0.5"/>
      <circle cx="12" cy="7" r="0.8" fill="#fff" opacity="0.6"/>
      <path d="M4.5 21.5c0-4 3.5-7 7.5-7s7.5 3 7.5 7" fill="url(#gmsTabGrad)" stroke="#991b1b" strokeWidth="0.8" filter="url(#gmsTabShadow)"/>
      <path d="M7 16.5c.5-.3 3-1.5 5-1.5s4.5 1.2 5 1.5" stroke="#7f1d1d" strokeWidth="0.6" fill="none" opacity="0.5"/>
      <path d="M12 1.5l-1.5 2.5h3l-1.5 2.5" stroke="#fcd34d" strokeWidth="1.8" fill="none" strokeLinecap="round" strokeLinejoin="round" filter="url(#gmsTabShadow)"/>
      <circle cx="12" cy="2.8" r="0.6" fill="#fef3c7" opacity="0.8"/>
    </svg>
  ),
  announcements: (
    <svg viewBox="0 0 24 24" width="18" height="18" className="tab-icon">
      <defs>
        <linearGradient id="announceTabGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#93c5fd" />
          <stop offset="50%" stopColor="#3b82f6" />
          <stop offset="100%" stopColor="#2563eb" />
        </linearGradient>
        <linearGradient id="announcePaperGrad" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#fef3c7" stopOpacity="0.8"/>
          <stop offset="100%" stopColor="#fde68a" stopOpacity="0.4"/>
        </linearGradient>
        <filter id="announceTabShadow">
          <feDropShadow dx="0" dy="1" stdDeviation="1.5" floodOpacity="0.3"/>
        </filter>
      </defs>
      <g filter="url(#announceTabShadow)">
        <path d="M19 7a7 7 0 010 10M5 7a7 7 0 000 10" stroke="url(#announceTabGrad)" strokeWidth="1.5" fill="none" strokeLinecap="round" opacity="0.5"/>
        <path d="M17 8.5a4 4 0 010 7M7 8.5a4 4 0 000 7" stroke="url(#announceTabGrad)" strokeWidth="1.2" fill="none" strokeLinecap="round" opacity="0.7"/>
        <rect x="8" y="3" width="8" height="18" rx="2" fill="url(#announcePaperGrad)" stroke="url(#announceTabGrad)" strokeWidth="1.3"/>
        <rect x="8.8" y="3.8" width="6.4" height="16.4" rx="1.2" fill="none" stroke="#1e40af" strokeWidth="0.3" opacity="0.2"/>
        <line x1="10" y1="7" x2="14" y2="7" stroke="url(#announceTabGrad)" strokeWidth="1.8" strokeLinecap="round"/>
        <line x1="10" y1="10" x2="14" y2="10" stroke="url(#announceTabGrad)" strokeWidth="1.5" strokeLinecap="round"/>
        <line x1="10" y1="13" x2="13" y2="13" stroke="url(#announceTabGrad)" strokeWidth="1.2" strokeLinecap="round"/>
        <line x1="10" y1="16" x2="12" y2="16" stroke="url(#announceTabGrad)" strokeWidth="1" strokeLinecap="round"/>
        <path d="M8 6.5l-3 1v7l3 1" fill="none" stroke="url(#announceTabGrad)" strokeWidth="0.8" opacity="0.6"/>
        <path d="M16 6.5l3 1v7l-3 1" fill="none" stroke="url(#announceTabGrad)" strokeWidth="0.8" opacity="0.6"/>
      </g>
    </svg>
  )
}

// Server SVG Icons - Enhanced with shadows, glows and animations
const ServerIcons = {
  online: (
    <svg viewBox="0 0 24 24" width="40" height="40" aria-hidden className="server-icon server-icon--online">
      <defs>
        <linearGradient id="serverOnline" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#a7f3d0" />
          <stop offset="50%" stopColor="#34d399" />
          <stop offset="100%" stopColor="#10b981" />
        </linearGradient>
        <filter id="onlineGlow">
          <feGaussianBlur stdDeviation="1.5" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      <circle cx="12" cy="12" r="10" fill="url(#serverOnline)" stroke="#065f46" strokeWidth="1.5" filter="url(#onlineGlow)"/>
      <circle cx="12" cy="12" r="7" fill="rgba(255,255,255,0.2)"/>
      <path d="M8.5 12.5l2 2 5-5" stroke="#064e3b" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  degraded: (
    <svg viewBox="0 0 24 24" width="40" height="40" aria-hidden className="server-icon server-icon--degraded">
      <defs>
        <linearGradient id="serverDegraded" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#fed7aa" />
          <stop offset="50%" stopColor="#fb923c" />
          <stop offset="100%" stopColor="#f97316" />
        </linearGradient>
        <filter id="degradedGlow">
          <feGaussianBlur stdDeviation="1.5" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      <circle cx="12" cy="12" r="10" fill="url(#serverDegraded)" stroke="#9a3412" strokeWidth="1.5" filter="url(#degradedGlow)"/>
      <circle cx="12" cy="12" r="7" fill="rgba(255,255,255,0.15)"/>
      <path d="M8 9h8M8 12h6M8 15h4" stroke="#7c2d12" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="19" cy="5" r="2" fill="#fbbf24" stroke="#92400e" strokeWidth="1">
        <animate attributeName="opacity" values="1;0.5;1" dur="1.5s" repeatCount="indefinite"/>
      </circle>
    </svg>
  ),
  updating: (
    <svg viewBox="0 0 24 24" width="40" height="40" aria-hidden className="server-icon server-icon--updating">
      <defs>
        <linearGradient id="serverUpdating" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#dbeafe" />
          <stop offset="50%" stopColor="#60a5fa" />
          <stop offset="100%" stopColor="#3b82f6" />
        </linearGradient>
        <filter id="updatingGlow">
          <feGaussianBlur stdDeviation="1.5" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      <circle cx="12" cy="12" r="10" fill="url(#serverUpdating)" stroke="#1e40af" strokeWidth="1.5" filter="url(#updatingGlow)"/>
      <circle cx="12" cy="12" r="7" fill="rgba(255,255,255,0.2)"/>
      <path d="M12 6v6l4 2" stroke="#1e3a8a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none">
        <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="2s" repeatCount="indefinite"/>
      </path>
    </svg>
  ),
  restarting: (
    <svg viewBox="0 0 24 24" width="40" height="40" aria-hidden className="server-icon server-icon--restarting">
      <defs>
        <linearGradient id="serverRestart" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#e9d5ff" />
          <stop offset="50%" stopColor="#a78bfa" />
          <stop offset="100%" stopColor="#7c3aed" />
        </linearGradient>
        <filter id="restartGlow">
          <feGaussianBlur stdDeviation="1.5" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      <circle cx="12" cy="12" r="10" fill="url(#serverRestart)" stroke="#5b21b6" strokeWidth="1.5" filter="url(#restartGlow)"/>
      <circle cx="12" cy="12" r="7" fill="rgba(255,255,255,0.2)"/>
      <path d="M15 8a5 5 0 1 0 .1 8" stroke="#4c1d95" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none">
        <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="2s" repeatCount="indefinite"/>
      </path>
      <path d="M17 6v4h-4" stroke="#4c1d95" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none">
        <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="2s" repeatCount="indefinite"/>
      </path>
    </svg>
  ),
  maintenance: (
    <svg viewBox="0 0 24 24" width="40" height="40" aria-hidden className="server-icon server-icon--maintenance">
      <defs>
        <linearGradient id="serverMaint" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#fef3c7" />
          <stop offset="50%" stopColor="#fbbf24" />
          <stop offset="100%" stopColor="#f59e0b" />
        </linearGradient>
        <filter id="maintGlow">
          <feGaussianBlur stdDeviation="1.5" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      <circle cx="12" cy="12" r="10" fill="url(#serverMaint)" stroke="#92400e" strokeWidth="1.5" filter="url(#maintGlow)"/>
      <circle cx="12" cy="12" r="7" fill="rgba(255,255,255,0.2)"/>
      <path d="M10 6l-4 10h12l-4-10" stroke="#78350f" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12 10v4M12 16h.01" stroke="#78350f" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  offline: (
    <svg viewBox="0 0 24 24" width="40" height="40" aria-hidden className="server-icon server-icon--offline">
      <defs>
        <linearGradient id="serverOffline" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#fecaca" />
          <stop offset="50%" stopColor="#f87171" />
          <stop offset="100%" stopColor="#ef4444" />
        </linearGradient>
        <filter id="offlineGlow">
          <feGaussianBlur stdDeviation="1.5" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      <circle cx="12" cy="12" r="10" fill="url(#serverOffline)" stroke="#991b1b" strokeWidth="1.5" filter="url(#offlineGlow)"/>
      <circle cx="12" cy="12" r="7" fill="rgba(255,255,255,0.15)"/>
      <path d="M8 8l8 8M16 8l-8 8" stroke="#7f1d1d" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

const AdminPanel = ({ isOpen, onClose, user, onServerStatusChange }) => {
  const [activeTab, setActiveTab] = useState('clients')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [success, setSuccess] = useState(null)
  
  // Data states
  const [clients, setClients] = useState([])
  const [onlineClients, setOnlineClients] = useState([])
  const [serverStatus, setServerStatus] = useState(null)
  const [globalStats, setGlobalStats] = useState(null)
  
  // Pagination
  const [clientsPage, setClientsPage] = useState(1)
  const [totalClients, setTotalClients] = useState(0)
  
  // Client filters
  const [searchQuery, setSearchQuery] = useState('')
  const [onlineFilter, setOnlineFilter] = useState('all')
  const [statusFilter, setStatusFilter] = useState('all')
  const [hasCharacterFilter, setHasCharacterFilter] = useState('all')
  const [sortBy, setSortBy] = useState('createdAt')
  const [sortOrder, setSortOrder] = useState('DESC')
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false)
  const [isSearching, setIsSearching] = useState(false)
  
  // Server control state
  const [serverMessage, setServerMessage] = useState('')
  const [estimatedRecovery, setEstimatedRecovery] = useState('')

  // Tabs modal state
  const [tabsModalOpen, setTabsModalOpen] = useState(false)
  const [selectedClient, setSelectedClient] = useState(null)

  // Client details modal state
  const [clientDetailsModalOpen, setClientDetailsModalOpen] = useState(false)
  const [selectedClientForDetails, setSelectedClientForDetails] = useState(null)

  // Check if user is admin
  const isAdmin = user?.isAdmin || false

  const loadGlobalStats = async () => {
    try {
      const res = await API.Admin.getStats()
      if (res.success) {
        setGlobalStats(res.data)
      }
    } catch (err) {
      console.error('Failed to load global stats:', err)
    }
  }

  const loadTabData = async () => {
    if (!isAdmin) return
    setLoading(true)
    setError(null)

    try {
      switch (activeTab) {
        case 'clients':
          await Promise.all([loadClients(), loadGlobalStats()])
          break
        case 'server':
          await loadServerStatus()
          break
        case 'stats':
          // AdminStatsDashboard handles its own loading
          break
        case 'bot':
          // BotManager handles its own loading
          break
        case 'resources':
          // ResourcesManager handles its own loading
          break
      }
    } catch (err) {
      console.error('Failed to load data:', err)
      setError('Failed to load data')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (isOpen && isAdmin) {
      loadTabData()
    }
  }, [isOpen, activeTab, clientsPage, isAdmin])
  
  // Reset page when filters change
  useEffect(() => {
    if (activeTab === 'clients') {
      setClientsPage(1)
      if (isOpen && isAdmin) {
        loadClients()
      }
    }
  }, [searchQuery, onlineFilter, statusFilter, hasCharacterFilter, sortBy, sortOrder])

  const loadClients = async () => {
    setIsSearching(true)
    try {
      const params = {
        page: clientsPage,
        limit: 10,
        sortBy,
        sortOrder,
      }

      if (statusFilter && statusFilter !== 'all') params.status = statusFilter
      if (hasCharacterFilter && hasCharacterFilter !== 'all') params.hasCharacter = hasCharacterFilter
      if (onlineFilter && onlineFilter !== 'all') params.tokenType = onlineFilter
      if (searchQuery && searchQuery.length >= 3) params.search = searchQuery

      const response = await API.Clients.list(params)
      if (response.success) {
        setClients(response.data || [])
        setTotalClients(response.pagination?.total || 0)
      }
    } finally {
      setIsSearching(false)
    }
  }

  const loadOnlineClients = async () => {
    const response = await API.Clients.getOnline(onlineFilter === 'all' ? 'app' : onlineFilter)
    if (response.success) {
      setOnlineClients(response.data || [])
    }
  }

  const loadServerStatus = async () => {
    const response = await API.Server.getStatus()
    if (response.success) {
      setServerStatus(response.data)
    } else if (response.code === 'SERVER_OFFLINE') {
      setServerStatus({
        status: 'offline',
        message: response.message || null,
        estimatedRecoveryAt: response.estimatedRecoveryAt || null,
        lastModifiedByAdminName: response.lastModifiedByAdminName || null,
      })
    }
  }

  const handleServerStatusChange = async (status) => {
    setError(null)
    setSuccess(null)
    setLoading(true)
    
    let response
    const message = serverMessage || null
    const recovery = estimatedRecovery ? new Date(estimatedRecovery).toISOString() : null
    
    try {
      switch (status) {
        case 'online':
          response = await API.Server.setOnline(message)
          break
        case 'offline':
          response = await API.Server.setOffline(message, recovery)
          break
        case 'maintenance':
          response = await API.Server.setMaintenance(message, recovery)
          break
        case 'updating':
          response = await API.Server.setUpdating(message, recovery)
          break
        case 'degraded':
          response = await API.Server.setDegraded(message)
          break
        case 'restarting':
          response = await API.Server.setRestarting(message, recovery)
          break
      }
      
      if (response?.success) {
        setSuccess(`Server status changed to ${status.toUpperCase()} successfully!`)
        setServerMessage('')
        setEstimatedRecovery('')
        await loadServerStatus()
        // Notify parent to refresh global status
        if (onServerStatusChange) {
          onServerStatusChange()
        }
      } else {
        setError(response?.error || 'Failed to update server status')
      }
    } catch (err) {
      setError('An error occurred while updating server status')
    } finally {
      setLoading(false)
    }
  }

  const formatDate = (dateString) => {
    if (!dateString) return 'Never'
    return new Date(dateString).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    })
  }

  // Don't render if user is not admin
  if (!isAdmin) return null

  return (
    <>
    <Modal 
      isOpen={isOpen} 
      onClose={onClose} 
      title="⚔️ Admin Panel"
      modalClassName="admin-modal"
    >
      <div className="admin-panel">
        {/* Tabs */}
        <div className="admin-tabs">
          {Object.entries(TabIcons).map(([key, icon]) => (
            <button
              key={key}
              className={`admin-tab ${activeTab === key ? 'admin-tab--active' : ''}`}
              onClick={() => setActiveTab(key)}
            >
              {icon}
              <span>
                  {key === 'bot' ? 'Unity-BOT' : 
                   key === 'resources' ? 'Resources' :
                   key === 'gms' ? 'GMs' :
                   key === 'announcements' ? 'News' :
                   key.charAt(0).toUpperCase() + key.slice(1)}
              </span>
            </button>
          ))}
        </div>

        {/* Error Message */}
        {error && (
          <div className="admin-error">
              <span className="admin-error-inner">
                <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden className="admin-icon admin-icon--warning">
                  <defs>
                    <linearGradient id="warnGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                      <stop offset="0%" stopColor="#fde68a" />
                      <stop offset="100%" stopColor="#f59e0b" />
                    </linearGradient>
                    <filter id="warnGlow">
                      <feDropShadow dx="0" dy="1" stdDeviation="1.5" floodColor="#f59e0b" floodOpacity="0.5"/>
                    </filter>
                  </defs>
                  <path d="M1 21h22L12 2 1 21z" fill="url(#warnGrad)" stroke="#92400e" strokeWidth="1.2" filter="url(#warnGlow)"/>
                  <rect x="11" y="8" width="2" height="7" rx="1" fill="#78350f" />
                  <circle cx="12" cy="18" r="1.2" fill="#78350f" />
                </svg>
                {typeof error === 'object' ? error?.message || 'An error occurred' : error}
              </span>
              <button onClick={() => setError(null)}>×</button>
            </div>
        )}

        {/* Loading Skeleton */}
        {loading ? (
          <div className="admin-loading-skeleton">
            {activeTab === 'clients' && (
              <div className="admin-skeleton-clients">
                <div className="admin-skeleton-header">
                  <Skeleton width="200px" height="24px" />
                </div>
                <div className="admin-skeleton-filters">
                  <Skeleton width="100px" height="20px" />
                  <Skeleton width="250px" height="36px" borderRadius="6px" />
                </div>
                <ClientsListSkeleton count={5} />
              </div>
            )}
            {activeTab === 'server' && (
              <div className="admin-skeleton-server">
                <div className="admin-skeleton-status-card">
                  <Skeleton width="60px" height="60px" borderRadius="50%" />
                  <div className="admin-skeleton-status-info">
                    <Skeleton width="100px" height="24px" />
                    <Skeleton width="150px" height="16px" style={{ marginTop: '8px' }} />
                  </div>
                </div>
                <div className="admin-skeleton-controls">
                  <Skeleton width="100%" height="40px" borderRadius="8px" />
                  <div className="admin-skeleton-buttons">
                    <Skeleton width="120px" height="36px" borderRadius="6px" />
                    <Skeleton width="120px" height="36px" borderRadius="6px" />
                    <Skeleton width="120px" height="36px" borderRadius="6px" />
                  </div>
                </div>
              </div>
            )}
            {activeTab === 'bot' && (
              <div className="admin-skeleton-stats">
                <Skeleton width="100%" height="80px" borderRadius="12px" />
                <Skeleton width="100%" height="40px" borderRadius="8px" />
                <Skeleton width="100%" height="120px" borderRadius="12px" />
              </div>
            )}
          </div>
        ) : (
          <div className="admin-content admin-content--loaded">
            {/* Clients Tab */}
            {activeTab === 'clients' && (
              <div className="admin-clients">
                <div className="admin-section-header">
                  <h4>Registered Clients ({totalClients})</h4>
                </div>

                {/* Quick Stats */}
                <div className="admin-quick-stats">
                  <div className="admin-quick-stat">
                    <span className="admin-quick-stat-value">{globalStats?.accounts?.total ?? totalClients}</span>
                    <span className="admin-quick-stat-label">Total Clients</span>
                  </div>
                  <div className="admin-quick-stat">
                    <span className="admin-quick-stat-value admin-quick-stat-value--green">{globalStats?.accounts?.active ?? 0}</span>
                    <span className="admin-quick-stat-label">Active</span>
                  </div>
                  <div className="admin-quick-stat">
                    <span className="admin-quick-stat-value admin-quick-stat-value--red">{(globalStats?.accounts?.banned ?? 0) + (globalStats?.accounts?.suspended ?? 0)}</span>
                    <span className="admin-quick-stat-label">Banned/Suspended</span>
                  </div>
                  <div className="admin-quick-stat">
                    <span className="admin-quick-stat-value admin-quick-stat-value--green">{globalStats?.accounts?.verifiedEmail ?? 0}</span>
                    <span className="admin-quick-stat-label">Verified Email</span>
                    <span className="admin-quick-stat-sub">{globalStats?.accounts?.total ? Math.round(globalStats.accounts.verifiedEmail / globalStats.accounts.total * 100) : 0}%</span>
                  </div>
                  <div className="admin-quick-stat">
                    <span className="admin-quick-stat-value admin-quick-stat-value--green">{globalStats?.sessions?.activeApp ?? 0}</span>
                    <span className="admin-quick-stat-label">App Online</span>
                    <span className="admin-quick-stat-sub">{globalStats?.sessions?.activeSite ?? 0} site</span>
                  </div>
                  <div className="admin-quick-stat">
                    <span className="admin-quick-stat-value admin-quick-stat-value--gold">{globalStats?.characters?.total ?? 0}</span>
                    <span className="admin-quick-stat-label">Total Characters</span>
                    <span className="admin-quick-stat-sub">{globalStats?.characters?.avgPerClient ?? 0} avg/client</span>
                  </div>
                  <div className="admin-quick-stat">
                    <span className="admin-quick-stat-value admin-quick-stat-value--green">{globalStats?.characters?.online ?? 0}</span>
                    <span className="admin-quick-stat-label">Chars Online</span>
                    <span className="admin-quick-stat-sub">{globalStats?.characters?.clientsWithoutCharacters ?? 0} without</span>
                  </div>
                  <div className="admin-quick-stat">
                    <span className="admin-quick-stat-value admin-quick-stat-value--blue">{globalStats?.licenses?.totalIssued ?? 0}</span>
                    <span className="admin-quick-stat-label">Licenses</span>
                    <span className="admin-quick-stat-sub">{globalStats?.licenses?.totalPermanentTabs ?? 0} perm. tabs</span>
                  </div>
                  <div className="admin-quick-stat">
                    <span className="admin-quick-stat-value admin-quick-stat-value--orange">{globalStats?.newtabs?.active ?? 0}</span>
                    <span className="admin-quick-stat-label">PAX Ativos</span>
                    <span className="admin-quick-stat-sub">{globalStats?.newtabs?.activeQuantity ?? 0} tabs</span>
                  </div>
                  <div className="admin-quick-stat">
                    <span className="admin-quick-stat-value admin-quick-stat-value--purple">{globalStats?.gms?.active ?? 0}</span>
                    <span className="admin-quick-stat-label">GMs Active</span>
                    <span className="admin-quick-stat-sub">of {globalStats?.gms?.total ?? 0}</span>
                  </div>
                </div>
                
                {/* Filters */}
                <div className="admin-filters">
                  <div className="admin-filters-row">
                    <div className="admin-filter-group">
                      <span className="admin-filter-label">Online:</span>
                      {['all', 'app', 'site', 'both'].map(value => (
                        <label key={value} className={`admin-filter-radio ${onlineFilter === value ? 'admin-filter-radio--active' : ''}`}>
                          <input type="radio" name="onlineFilter" value={value}
                            checked={onlineFilter === value}
                            onChange={(e) => setOnlineFilter(e.target.value)}
                          />
                          <span>{value === 'all' ? 'All' : value === 'app' ? 'APP Online' : value === 'site' ? 'Site Online' : 'Both'}</span>
                        </label>
                      ))}
                    </div>

                    <div className="admin-filter-search">
                      <svg viewBox="0 0 24 24" width="18" height="18" className="admin-search-icon">
                        <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="2" fill="none"/>
                        <path d="M16 16l5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                      </svg>
                      <input type="text" placeholder="Search by username, email..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        className="admin-search-input"
                      />
                      {searchQuery && (
                        <button className="admin-search-clear" onClick={() => setSearchQuery('')} title="Clear search">×</button>
                      )}
                    </div>

                    <button
                      className={`admin-advanced-toggle ${showAdvancedFilters ? 'admin-advanced-toggle--open' : ''}`}
                      onClick={() => setShowAdvancedFilters(v => !v)}
                      title="Toggle advanced filters"
                    >
                      <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                        <path d="M4 4h16v2.17a2 2 0 0 1-.59 1.42L14 13v6l-4 2v-8L4.59 7.59A2 2 0 0 1 4 6.17V4z"/>
                      </svg>
                      Filters
                      {(statusFilter !== 'all' || hasCharacterFilter !== 'all' || sortBy !== 'createdAt') && (
                        <span className="admin-filter-badge">!</span>
                      )}
                    </button>
                  </div>

                  {showAdvancedFilters && (
                    <div className="admin-filters-advanced">
                      <div className="admin-filter-group">
                        <span className="admin-filter-label">Status:</span>
                        {['all', 'active', 'banned', 'suspended', 'inactive'].map(value => (
                          <label key={value} className={`admin-filter-radio ${statusFilter === value ? 'admin-filter-radio--active' : ''}`}>
                            <input type="radio" name="statusFilter" value={value}
                              checked={statusFilter === value}
                              onChange={(e) => setStatusFilter(e.target.value)}
                            />
                            <span>{value.charAt(0).toUpperCase() + value.slice(1)}</span>
                          </label>
                        ))}
                      </div>

                      <div className="admin-filter-group">
                        <span className="admin-filter-label">Characters:</span>
                        {['all', 'yes', 'no'].map(value => (
                          <label key={value} className={`admin-filter-radio ${hasCharacterFilter === value ? 'admin-filter-radio--active' : ''}`}>
                            <input type="radio" name="hasCharacterFilter" value={value}
                              checked={hasCharacterFilter === value}
                              onChange={(e) => setHasCharacterFilter(e.target.value)}
                            />
                            <span>{value === 'all' ? 'All' : value === 'yes' ? 'With Characters' : 'Without'}</span>
                          </label>
                        ))}
                      </div>

                      <div className="admin-filter-group">
                        <span className="admin-filter-label">Sort:</span>
                        <select className="admin-filter-select" value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
                          <option value="createdAt">Created</option>
                          <option value="lastLoginAt">Last Login</option>
                          <option value="username">Username</option>
                        </select>
                        <button
                          className="admin-filter-order"
                          onClick={() => setSortOrder(o => o === 'DESC' ? 'ASC' : 'DESC')}
                          title={sortOrder === 'DESC' ? 'Newest first' : 'Oldest first'}
                        >
                          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2"
                            style={{ transform: sortOrder === 'DESC' ? 'rotate(180deg)' : 'none' }}>
                            <path d="M12 5v14M5 12l7 7 7-7"/>
                          </svg>
                        </button>
                      </div>
                    </div>
                  )}
                </div>
                
                {isSearching && (
                  <div className="admin-searching-skeleton">
                    <Skeleton width="100%" height="48px" borderRadius="6px" />
                    <Skeleton width="100%" height="48px" borderRadius="6px" />
                    <Skeleton width="100%" height="48px" borderRadius="6px" />
                  </div>
                )}
                
                <div className="admin-table-container">
                  <table className="admin-table">
                    <thead>
                      <tr>
                        <th>Username</th>
                        <th>Email</th>
                        <th>Characters</th>
                        <th>APP</th>
                        <th>Site</th>
                        <th>Tabs</th>
                        <th>Status</th>
                        <th>Last Login</th>
                      </tr>
                    </thead>
                    <tbody>
                      {clients.map(client => {
                        const isInactive = !client.isActive && !client.isEmailVerified
                        const isTemporarilyBanned = !client.isActive && client.isEmailVerified && client.inactiveUntil
                        const status = client.isActive ? 'active' : (isInactive ? 'inactive' : (isTemporarilyBanned ? 'suspended' : 'banned'))
                        const statusLabel = client.isActive ? 'Active' : (isInactive ? 'Inactive' : (isTemporarilyBanned ? 'Suspended' : 'Banned'))
                        const totalChars = client.totalCharacters ?? 0
                        const onlineChars = client.onlineCharacters ?? 0
                        
                        const handleRowClick = () => {
                          setSelectedClientForDetails(client)
                          setClientDetailsModalOpen(true)
                        }
                        
                        return (
                        <tr 
                          key={client.id} 
                          className={`admin-table__row--clickable ${!client.isActive && client.isEmailVerified ? 'admin-table__row--banned' : ''}`}
                          onClick={handleRowClick}
                          title="Click to view client details"
                        >
                          <td>
                            <span className="admin-username">
                              {client.isAdmin && (
                                <span className="admin-crown" aria-hidden>
                                  <svg viewBox="0 0 24 24" width="16" height="16">
                                    <defs>
                                      <linearGradient id="crownGold" x1="0%" y1="0%" x2="100%" y2="100%">
                                        <stop offset="0%" stopColor="#fde68a" />
                                        <stop offset="50%" stopColor="#fbbf24" />
                                        <stop offset="100%" stopColor="#f59e0b" />
                                      </linearGradient>
                                      <filter id="crownGlow">
                                        <feDropShadow dx="0" dy="1" stdDeviation="1" floodColor="#f59e0b" floodOpacity="0.6"/>
                                      </filter>
                                    </defs>
                                    <path d="M2 17l3-7 4 4 5-10 4 7 4-4v11H2z" fill="url(#crownGold)" stroke="#92400e" strokeWidth="0.8" filter="url(#crownGlow)"/>
                                    <circle cx="5" cy="10" r="1.5" fill="#ef4444" stroke="#92400e" strokeWidth="0.5"/>
                                    <circle cx="12" cy="7" r="1.8" fill="#ef4444" stroke="#92400e" strokeWidth="0.5"/>
                                    <circle cx="19" cy="10" r="1.5" fill="#ef4444" stroke="#92400e" strokeWidth="0.5"/>
                                  </svg>
                                </span>
                              )}
                              {client.username}
                            </span>
                          </td>
                          <td className="admin-table__email">{client.email}</td>
                          <td>
                            <span className="admin-chars-cell">
                              <span className="admin-chars-total">{totalChars}</span>
                              <span className={`admin-chars-online ${onlineChars === 0 ? 'admin-chars-online--none' : ''}`}>
                                <span className="admin-online-dot" />
                                {onlineChars} online
                              </span>
                            </span>
                          </td>
                          <td>
                            <span className={`admin-session-status ${client.isAppOnline ? 'admin-session-status--online' : 'admin-session-status--offline'}`}>
                              <span className="admin-session-dot" />
                              {client.isAppOnline ? 'Online' : 'Offline'}
                            </span>
                          </td>
                          <td>
                            <span className={`admin-session-status ${client.isSiteOnline ? 'admin-session-status--online' : 'admin-session-status--offline'}`}>
                              <span className="admin-session-dot" />
                              {client.isSiteOnline ? 'Online' : 'Offline'}
                            </span>
                          </td>
                          <td className="admin-table__tabs">{client.totalTabs ?? 0}</td>
                          <td>
                            <span className={`admin-status-badge admin-status-badge--${status}`}>
                              {statusLabel}
                            </span>
                          </td>
                          <td className="admin-table__date">{formatDate(client.lastLoginAt)}</td>
                        </tr>
                      )})}
                    </tbody>
                  </table>
                </div>

                {/* Pagination */}
                {totalClients > 10 && (
                  <div className="admin-pagination">
                    <button 
                      disabled={clientsPage <= 1}
                      onClick={() => setClientsPage(p => p - 1)}
                    >
                      ← Previous
                    </button>
                    <span>Page {clientsPage} of {Math.ceil(totalClients / 10)}</span>
                    <button 
                      disabled={clientsPage >= Math.ceil(totalClients / 10)}
                      onClick={() => setClientsPage(p => p + 1)}
                    >
                      Next →
                    </button>
                  </div>
                )}
              </div>
            )}

            {/* Server Tab */}
            {activeTab === 'server' && (
              <div className="admin-server">
                <div className="admin-section-header">
                  <h4>Server Control</h4>
                  <button className="bot-manager__btn bot-manager__btn--primary bot-manager__btn--small" onClick={loadServerStatus}>
                    <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden style={{marginRight:8}} className="refresh-icon">
                      <defs>
                        <linearGradient id="refreshGrad2" x1="0%" y1="0%" x2="100%" y2="100%">
                          <stop offset="0%" stopColor="#60a5fa" />
                          <stop offset="100%" stopColor="#3b82f6" />
                        </linearGradient>
                      </defs>
                      <path d="M21 12a9 9 0 1 0-2.6 6.1" stroke="url(#refreshGrad2)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
                      <path d="M21 3v6h-6" stroke="url(#refreshGrad2)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
                    </svg>
                    Refresh
                  </button>
                </div>

                {/* Success Message */}
                {success && (
                  <div className="admin-success">
                    <span className="admin-success-inner">
                      <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden className="admin-icon admin-icon--success">
                        <defs>
                          <linearGradient id="successGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                            <stop offset="0%" stopColor="#6ee7b7" />
                            <stop offset="100%" stopColor="#10b981" />
                          </linearGradient>
                          <filter id="successGlow">
                            <feDropShadow dx="0" dy="1" stdDeviation="1.5" floodColor="#10b981" floodOpacity="0.5"/>
                          </filter>
                        </defs>
                        <circle cx="12" cy="12" r="10" fill="url(#successGrad)" stroke="#065f46" strokeWidth="1.2" filter="url(#successGlow)"/>
                        <path d="M7 12l3 3 7-7" stroke="#064e3b" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
                      </svg>
                      {success}
                    </span>
                    <button onClick={() => setSuccess(null)}>×</button>
                  </div>
                )}

                {/* Current Status Card */}
                <div className="admin-server-current">
                  <div className="admin-server-current-header">
                    <h5>Current Status</h5>
                    <span className={`admin-status-badge admin-status-badge--${serverStatus?.status || 'offline'}`}>
                      {serverStatus?.status?.toUpperCase() || 'UNKNOWN'}
                    </span>
                  </div>
                  {serverStatus?.message && (
                    <p className="admin-server-current-message">{serverStatus.message}</p>
                  )}
                  {serverStatus?.lastModifiedByAdminName && (
                    <p className="admin-server-current-admin">
                      <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden style={{marginRight:6}}>
                        <circle cx="12" cy="8" r="4" fill="currentColor"/>
                        <path d="M4 21c0-4 3.5-7 8-7s8 3 8 7" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round"/>
                      </svg>
                      Modified by<strong>{serverStatus.lastModifiedByAdminName}</strong>
                    </p>
                  )}
                  {serverStatus?.estimatedRecoveryAt && (
                    <p className="admin-server-current-recovery">
                      <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden style={{marginRight:6}}>
                        <path d="M12 6v6l4 2" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
                        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.2" fill="none"/>
                      </svg>
                      Estimated Recovery: {new Date(serverStatus.estimatedRecoveryAt).toLocaleString()}
                    </p>
                  )}
                  {serverStatus?.updatedAt && (
                    <p className="admin-server-current-time">
                      Last updated: {new Date(serverStatus.updatedAt).toLocaleString()}
                    </p>
                  )}
                </div>

                <h5 className="admin-section-subtitle">Change Server Status</h5>

                {/* Configuration Inputs */}
                <div className="admin-server-config">
                  <div className="admin-server-input">
                    <label>Status Message (Optional)</label>
                    <input 
                      type="text" 
                      value={serverMessage}
                      onChange={(e) => setServerMessage(e.target.value)}
                      placeholder="e.g., Scheduled maintenance for updates"
                      disabled={loading}
                    />
                  </div>

                  <div className="admin-server-input">
                    <label>Estimated Recovery (Optional)</label>
                    <input 
                      type="datetime-local" 
                      value={estimatedRecovery}
                      onChange={(e) => setEstimatedRecovery(e.target.value)}
                      disabled={loading}
                    />
                  </div>
                </div>

                {/* Status Cards Grid */}
                <div className="admin-server-grid">
                  <button 
                    className="admin-server-card admin-server-card--online"
                    onClick={() => handleServerStatusChange('online')}
                    disabled={loading}
                  >
                    <span className="admin-server-card-icon">{ServerIcons.online}</span>
                    <span className="admin-server-card-title">Online</span>
                    <span className="admin-server-card-desc">Normal operation</span>
                  </button>
                  
                  <button 
                    className="admin-server-card admin-server-card--degraded"
                    onClick={() => handleServerStatusChange('degraded')}
                    disabled={loading}
                  >
                    <span className="admin-server-card-icon">{ServerIcons.degraded}</span>
                    <span className="admin-server-card-title">Degraded</span>
                    <span className="admin-server-card-desc">Reduced performance</span>
                  </button>

                  <button 
                    className="admin-server-card admin-server-card--updating"
                    onClick={() => handleServerStatusChange('updating')}
                    disabled={loading}
                  >
                    <span className="admin-server-card-icon">{ServerIcons.updating}</span>
                    <span className="admin-server-card-title">Updating</span>
                    <span className="admin-server-card-desc">Installing updates</span>
                  </button>

                  <button 
                    className="admin-server-card admin-server-card--restarting"
                    onClick={() => handleServerStatusChange('restarting')}
                    disabled={loading}
                  >
                    <span className="admin-server-card-icon">{ServerIcons.restarting}</span>
                    <span className="admin-server-card-title">Restarting</span>
                    <span className="admin-server-card-desc">Server restart</span>
                  </button>

                  <button 
                    className="admin-server-card admin-server-card--maintenance"
                    onClick={() => handleServerStatusChange('maintenance')}
                    disabled={loading}
                  >
                    <span className="admin-server-card-icon">{ServerIcons.maintenance}</span>
                    <span className="admin-server-card-title">Maintenance</span>
                    <span className="admin-server-card-desc">Scheduled maintenance</span>
                  </button>

                  <button 
                    className="admin-server-card admin-server-card--offline"
                    onClick={() => handleServerStatusChange('offline')}
                    disabled={loading}
                  >
                    <span className="admin-server-card-icon">{ServerIcons.offline}</span>
                    <span className="admin-server-card-title">Offline</span>
                    <span className="admin-server-card-desc">Server down</span>
                  </button>
                </div>
              </div>
            )}

            {/* Bot Manager Tab */}
            {activeTab === 'bot' && (
              <BotManager />
            )}

            {/* Resources Manager Tab */}
            {activeTab === 'resources' && (
              <ResourcesManager />
            )}

            {/* GM Management Tab */}
            {activeTab === 'gms' && (
              <GMManager />
            )}

            {/* Announcements Tab */}
            {activeTab === 'announcements' && (
              <AnnouncementsManager />
            )}

            {/* Stats Tab */}
            {activeTab === 'stats' && (
              <AdminStatsDashboard />
            )}
          </div>
        )}
      </div>
    </Modal>
    
    {/* Tabs Management Modal */}
    <TabsModal 
      isOpen={tabsModalOpen}
      onClose={() => {
        setTabsModalOpen(false)
        setSelectedClient(null)
        loadOnlineClients() // Refresh list after closing
      }}
      client={selectedClient}
    />

    {/* Client Details Modal */}
    <ClientDetailsModal
      isOpen={clientDetailsModalOpen}
      onClose={() => {
        setClientDetailsModalOpen(false)
        setSelectedClientForDetails(null)
      }}
      client={selectedClientForDetails}
      onClientUpdated={() => {
        loadClients() // Refresh clients list after update
      }}
    />
    </>
  )
}

export default AdminPanel
